// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"34bc8f3b","780":"fd706c72","848":"7faa0c94"}[chunkId] + ".chunk.js";
};